<template>
  <div>

    <div class="row"> 

      <div class="col-md-12" v-if="isEdit">
      </div>

    </div>
  <div>
    <div class="row">
      <div class="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
        <div class="card card-wizard marketing-wizard" id="wizardCard">
          <form-wizard shape="square"
                      step-size="xs"
                       @on-complete="wizardComplete"
                       error-color="#EB5E28"
                       color="#5e35b1">
            
            <tab-content :before-change="validateFirstStep" title="Campaign Details">
              <first-step ref="firstStep" :modelFromParent="model"></first-step>
            </tab-content>

            <tab-content :before-change="validateSecondStep" title="Notifications">
              <second-step ref="secondStep" :modelFromParent="model" :daysParent="days"></second-step>
            </tab-content>

            <tab-content :before-change="validateThirdStep" title="Target">
              <third-step ref="thirdStep" :modelFromParent="model" :daysParent="days"></third-step>
            </tab-content>

            <tab-content :before-change="validateForthStep" title="Target">
              <forth-step ref="forthStep" 
                          :modelFromParent="model" 
                          :daysParent="days"
                          :couponsParent="coupons"
                          :groupedProductsParent="groupedProducts"></forth-step>
            </tab-content>

            <h2 slot="title"></h2>
            <button slot="prev" class="btn btn-purple-light btn btn-wd btn-back">{{$t('general.back')}}</button>
            <button slot="next" class="btn btn-purple-light btn-fill btn-wd btn-next">{{$t('general.next')}}</button>
            <button slot="finish" class="btn btn-purple-light btn-fill btn-wd">{{$t('general.finish')}}</button>
          </form-wizard>
        </div>
      </div>
    </div>

  </div>
</div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Select, TimeSelect} from 'element-ui'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import FirstStep from './Steps/FirstStep.vue'
  import SecondStep from './Steps/SecondStep.vue'
  import ThirdStep from './Steps/ThirdStep.vue'
  import ForthStep from './Steps/ForthStep.vue'
  import countriesList from './../../Customers/countries'
  import moment from 'moment'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      [TimeSelect.name]: TimeSelect,
      [Select.name]: Select,
      FormWizard,
      TabContent,
      FirstStep,
      SecondStep,
      ThirdStep,
      ForthStep
    },
    computed: {
      ...mapFields(['name', 'price', 'active', 'date_from'])
    },
    data () {
      return {
        days: [
          this.$t('days.monday'),
          this.$t('days.tuesday'),
          this.$t('days.wednesday'),
          this.$t('days.thursday'),
          this.$t('days.friday'),
          this.$t('days.saturday'),
          this.$t('days.sunday')
        ],
        campaignsNotificationTypes: this.$session.get('defaultData')['campaigns_notification_types'],
        countries: countriesList,
        model: [],
        coupons: [],
        groupedProducts: [],
        customerList: 0,
        modelValidations: {
          name: {
            required: true,
            min: 4
          },
          active: {
            required: true
          },
          price: {
            required: true
          },
          status: {
            required: true
          },
          date_from: {
          },
          coupon_code: {
            required: true,
            min: 4
          },
          coupon_option: {
          }
        },
        wizardModel: {}
      }
    },
    created: function () {
      this.getData()
    },
    methods: {
      getData () {
        var notifTimes = []
        var dayData = []
        for (var day in this.days) {
          var dayDataIdx = this.getObjectByElemKeyValue('day', this.days[day], notifTimes)
          if (dayDataIdx !== undefined && notifTimes[dayDataIdx] !== undefined) {
            notifTimes[dayDataIdx]['checked'] = true
            dayData.push(notifTimes[dayDataIdx])
          } else {
            dayData.push({day: this.days[day], hour_to: '', hour_from: '', checked: false})
          }
        }
        var notifTypesArray = []
        for (var type in this.campaignsNotificationTypes) {
          notifTypesArray[type] = false
        }
        this.model = {
          notification_times_array: dayData,
          notification_types_array: notifTypesArray,
          user_filters: {
            age: '',
            gender: '',
            orders_above: '',
            location_id: '',
            counter_matching_users: 0
          },
          imagelist: [],
          coupons: {},
          type: 'TEXT'
        }
        this.coupons = {
          type: 'PERCENTAGE',
          usage_type: null,
          discount: null,
          coupon_code: null
        }
        var self = this
        if (this.$route.params.id) {
          var data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          var id = self.$route.params.id
          self.apiRequest('/campaign/' + id, 'GET', data, function (response) {
            if (response.status === true) {
              // get coupons
              data['campaign_id'] = id
              self.apiRequest('/coupon', 'GET', data, function (response2) {
                if (response2.data[0] == null) {
                  response2.data[0] = {
                    type: '',
                    usage_type: '',
                    discount: '',
                    coupon_code: ''
                  }
                }
                self.coupons = response2.data[0]
              })

              // get valid date
              if (response.data[0].datetime_validfrom && response.data[0].datetime_validto) {
                response.data[0].fromto = [response.data[0].datetime_validfrom, response.data[0].datetime_validto]
              }

              // image object
              if (response.data[0]['image_url']) {
                response.data[0]['imagelist'] = response.data[0]['image_url']
              } else {
                response.data[0]['imagelist'] = []
              }

              // notifications time object
              var notifTimes = response.data[0]['notification_times']
              var dayData = []
              for (var day in self.days) {
                var checked = false
                var hourTo = ''
                var hourFrom = ''
                for (var nTime of notifTimes) {
                  if (nTime.day === self.days[day]) {
                    checked = true
                    hourTo = nTime.hour_to
                    hourFrom = nTime.hour_from
                  }
                }
                dayData.push({day: self.days[day], hour_to: hourTo, hour_from: hourFrom, checked: checked})
              }
              response.data[0]['notification_times_array'] = dayData
              var notifTypesArray = []
              var notifTypes = response.data[0]['notification_type']
              for (var type in self.campaignsNotificationTypes) {
                notifTypesArray.push({type: false})
                if (notifTypes !== null) {
                  for (var nType of notifTypes) {
                    if (nType.type === type) {
                      notifTypesArray[type] = true
                    }
                  }
                }
              }
              response.data[0]['notification_types_array'] = notifTypesArray
              // get model
              self.model = response.data[0]
            }
          })
        }
        var data2 = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          grouped: 1
        }
        this.apiRequest('/product', 'GET', data2, function (response) {
          if (response.status === true) {
            self.groupedProducts = response.data
            self.loaded = true
          }
        })
      },
      isEdit () {
        if (this.$route.params.id) {
          return true
        } else {
          return false
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          // this.$emit('on-submit', this.registerForm, isValid)
        })
      },
      validateFirstStep () {
        this.model = {...this.$refs.firstStep.model}
        return this.$refs.firstStep.validate()
      },
      validateSecondStep () {
        this.model = {...this.$refs.secondStep.model}
        return this.$refs.secondStep.validate()
      },
      validateThirdStep () {
        var ret = this.$refs.thirdStep.validate()
        this.model = {...this.$refs.thirdStep.model}
        return ret
      },
      validateForthStep () {
        this.model = {...this.$refs.forthStep.model}
        return this.$refs.forthStep.validate()
      },
      handleRemoveImage (file, fileList) {
      },
      filterCustomers () {
        this.customerList = 30
      },
      resetTable () {
        this.customerList = 0
      },
      saveCoupons (id, goToEdit, msg) {
        var self = this
        // save the coupons
        this.coupons = {...this.$refs.forthStep.coupons}
        let treeData = {...this.$refs.forthStep.treeData}

        var data = this.copyObject(this.coupons)
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        data.campaign_id = id

        // prepare tree data
        let categs = []
        let prods = []
        for (let idx in treeData) {
          if (treeData[idx]['checked'] !== undefined && treeData[idx]['checked'] === true && (treeData[idx]['halfcheck'] === false || treeData[idx]['halfcheck'] === undefined)) {
            categs.push(treeData[idx]['id'])
          } else {
            for (let idxChild in treeData[idx]['children']) {
              if (treeData[idx]['children'][idxChild] && treeData[idx]['children'][idxChild]['checked'] === true) {
                prods.push(treeData[idx]['children'][idxChild]['id'])
              }
            }
          }
        }
        data['usage_for_products'] = JSON.stringify(prods)
        data['usage_for_categories'] = JSON.stringify(categs)

        if (this.coupons.id !== null && this.coupons.id !== undefined && this.coupons.id !== '') {
          if (this.model.type === 'TEXT') {
            let data2 = []
            data2.token = this.$session.get('token')
            this.apiRequest('/coupon/' + this.coupons.id, 'DELETE', data2, function (response2) {
              if (response2.status === true) {
                swal(
                  {
                    title: '',
                    text: msg,
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                )
              } else {
                // error
              }
            })
          } else {
            delete data.deleted_at
            delete data.created_at
            delete data.updated_at
            delete data.created_by
            delete data.deleted_at
            delete data.deleted_by
            delete data.updated_by
            delete data.campaign
            this.apiRequest('/coupon/' + this.coupons.id, 'PUT', data, function (response2) {
              if (response2.status === true) {
                swal(
                  {
                    title: '',
                    text: msg,
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                )
              } else {
                // error
              }
            })
          }
        } else if (this.model.type === 'COUPON') {
          this.apiRequest('/coupon', 'POST', data, function (response2) {
            if (response2.status === true) {
              swal(
                {
                  title: '',
                  text: msg,
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
            } else {
              // error
            }
          })
        }

        swal(
          {
            title: '',
            text: msg,
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }
        )
        if (goToEdit) {
          // self.$router.push('/marketing/campaigns/edit/' + id)
          self.$router.push('/marketing/campaigns')
        }
      },
      wizardComplete () {
        // we gather models from all steps into one model
        // this.model = {
        //   ...this.$refs.firstStep.model,
        //   ...this.$refs.secondStep.model,
        //   ...this.$refs.thirdStep.model,
        //   ...this.$refs.forthStep.model
        // }

        // var go = false

        var self = this
        var data = this.copyObject(this.model)
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')

        if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
          data.datetime_validfrom = moment(this.model.fromto[0], moment.ISO_8601).format()
          data.datetime_validfrom = data.datetime_validfrom.slice(0, data.datetime_validfrom.indexOf('+'))
          data.datetime_validfrom = data.datetime_validfrom.replace('T', ' ')
          data.datetime_validto = moment(this.model.fromto[1], moment.ISO_8601).format()
          data.datetime_validto = data.datetime_validto.slice(0, data.datetime_validto.indexOf('+'))
          data.datetime_validto = data.datetime_validto.replace('T', ' ')
        } else {
          data.datetime_validfrom = null
          data.datetime_validto = null
        }

        var notificationTimes = []
        for (var timeKey in data.notification_times_array) {
          if (data.notification_times_array[timeKey].checked === true) {
            notificationTimes.push({day: data.notification_times_array[timeKey].day, hour_to: '', hour_from: data.notification_times_array[timeKey].hour_from})
          }
        }

        var notificationTypes = []
        for (let type in data.notification_types_array) {
          if (data.notification_types_array[type] === true) {
            notificationTypes.push({'type': type})
          }
        }

        data.user_filters.counter_matching_users = data.counter_matching_users

        if (data.description === {}) {
          data.description = ''
        }

        delete data.notification_times_array
        delete data.notification_types_array
        delete data.notification_times
        delete data.notification_type
        delete data.fromto
        delete data.image_url
        delete data.deleted_at
        delete data.created_at
        delete data.updated_at
        delete data.created_by
        delete data.deleted_at
        delete data.deleted_by
        delete data.updated_by
        delete data.counter_matching_users
        data.notification_times = JSON.stringify(notificationTimes)
        data.user_filters = JSON.stringify(data.user_filters)
        data.notification_type = JSON.stringify(notificationTypes)
        // if (!go) {
        //   return false
        // }
        // save
        if (!this.$route.params.id) {
          this.apiRequest('/campaign', 'POST', data, function (response) {
            if (response.status === true) {
              var id = response.data[0].id
              if (Object.keys(data.imagelist).length && data.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.name = data.name
                    data2.type = data.type
                    data2.mode = data.mode
                    data2.notification_type = data.notification_type
                    data2.image = base64enc
                    self.apiRequest('/campaign/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.saveCoupons(id, true, self.$t('marketingCampaigns.campaignAdded'))
                      } else {
                        swal(
                          {
                            title: '',
                            text: self.$t('marketingCampaigns.campaignPhotoError'),
                            type: 'error',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.saveCoupons(id, true, self.$t('marketingCampaigns.campaignAdded'))
              }
            }
          })
        } else {
          var id = this.$route.params.id
          // check if the've removed the picture
          if (data.imagelist === 0) {
            data.image_url = ''
          }
          this.apiRequest('/campaign/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              if (Object.keys(data.imagelist).length && data.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.image = base64enc
                    data2.name = data.name
                    data2.type = data.type
                    data2.mode = data.mode
                    data2.notification_type = data.notification_type
                    self.apiRequest('/campaign/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.saveCoupons(id, true, self.$t('marketingCampaigns.campaignUpdated'))
                      } else {
                        swal(
                          {
                            title: '',
                            text: self.$t('marketingCampaigns.campaignPhotoError'),
                            type: 'error',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.saveCoupons(id, true, self.$t('marketingCampaigns.campaignUpdated'))
                self.$router.push('/marketing/campaigns')
              }
            } else {
              // console.log(response.errors)
              // self.handleErrors(response.errors)
            }
          }) // end api response
        }
      },
      addNewCoupon () {
        let newRow = []
        newRow.id = 'new_' + Math.random()
        if (this.model.coupons === undefined) {
          this.model.coupons = []
        }
        this.model.coupons.push(newRow)
      },
      deleteCoupon (id) {
      }
    }
  }
</script>
<style>
  .upload-demo input[type="file"]{ display: none; }
  .el-date-editor.el-input{ max-width: 170px; }
  .padd{ padding: 4px 15px; }
  .el-select{ width: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/CampaignForm.vue